/**
 * mascot/avatar — public barrel for the split DjayAvatar render primitive.
 *
 * `src/mascot/DjayAvatar.tsx` re-exports from here, keeping the historical
 * `'./DjayAvatar'` import path (~50 call-sites) and the mascot barrel intact.
 */
export { DjayAvatar } from './DjayAvatarView';
export { VARIANT_COLORS } from './palette';
export { SIZES, DJAY_VIEWBOX, TREATMENT_META } from './types';
export type { DjaySize, DjayEmotion, DjayTier, DjayVariant, DjayAccessory, DjayTreatment, DjayAvatarProps, VariantColorScheme } from './types';